import React from 'react';
import { motion } from 'framer-motion';
export function DoctorTrust() {
  return <section className="py-10 lg:py-20 bg-brand-darkAlt" data-id="element-43">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-44">
        <div className="bg-white/5 rounded-3xl overflow-hidden border border-white/10 flex flex-col md:flex-row" data-id="element-45">
          {/* Image Placeholder */}
          <div className="md:w-2/5 relative min-h-[250px] lg:min-h-[400px] bg-white/5 flex items-center justify-center p-6 lg:p-8 border-b md:border-b-0 md:border-r border-white/10" data-id="element-46">
            <div className="text-center" data-id="element-47">
              <div className="w-24 h-24 lg:w-32 lg:h-32 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-3 lg:mb-4 border border-white/20" data-id="element-48">
                <span className="font-light text-3xl lg:text-4xl text-white" data-id="element-49">
                  JL
                </span>
              </div>
              <p className="font-light text-xl lg:text-2xl text-white" data-id="element-50">
                Dr. Julio Lima
              </p>
              <p className="text-sm lg:text-base text-white/50 mt-1" data-id="element-51">
                Lead Dentist
              </p>
            </div>
          </div>

          {/* Content */}
          <div className="md:w-3/5 p-6 md:p-12 lg:p-16 flex flex-col justify-center" data-id="element-52">
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-53">
              <h2 className="text-3xl md:text-4xl font-light text-white mb-4 lg:mb-6" data-id="element-54">
                Meet Dr. Julio Lima
              </h2>

              <div className="space-y-3 lg:space-y-4 text-white/60 text-base lg:text-lg leading-relaxed" data-id="element-55">
                <p data-id="element-56">
                  For over 35 years, Dr. Lima has been a trusted cornerstone of
                  the Miami Lakes community. He believes dentistry is about more
                  than just teeth—it's about building relationships and
                  restoring confidence.
                </p>
                <p data-id="element-57">
                  Unlike corporate dental chains where you might see a different
                  doctor every visit, Dr. Lima personally oversees every
                  Invisalign case from the initial scan to your final, perfect
                  smile.
                </p>
                <p className="italic text-white/80" data-id="element-58">
                  "My greatest joy is seeing a patient look in the mirror and
                  finally love the smile looking back at them."
                </p>
              </div>

              <div className="mt-6 lg:mt-8 pt-6 lg:pt-8 border-t border-white/10 flex flex-wrap gap-2 lg:gap-4" data-id="element-59">
                <span className="bg-white/5 px-3 lg:px-4 py-1.5 lg:py-2 rounded-full text-xs lg:text-sm font-medium text-white/70 border border-white/10" data-id="element-60">
                  35+ Years Experience
                </span>
                <span className="bg-white/5 px-3 lg:px-4 py-1.5 lg:py-2 rounded-full text-xs lg:text-sm font-medium text-white/70 border border-white/10" data-id="element-61">
                  Local Family Practice
                </span>
                <span className="bg-white/5 px-3 lg:px-4 py-1.5 lg:py-2 rounded-full text-xs lg:text-sm font-medium text-white/70 border border-white/10" data-id="element-62">
                  Invisalign Provider
                </span>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}